module.exports = __webpack_public_path__ + "img/logotipo.059a5f8a.png";